import { clone, fill } from 'lodash';

export function duplicate<T>(item: T, count: number): T[] {
  return fill(Array(count), {}).map(() => clone(item));
}

export class UniqueCounter {
  items: Record<string, number> = {} as Record<string, number>;

  constructor(items: string[] = []) {
    for (const item of items) {
      this.add(item);
    }
  }

  add(item: string): void {
    if (item) {
      this.items[item] = (this.items[item] ?? 0) + 1;
    }
  }

  count(item: string): number {
    return this.items[item] ?? 0;
  }

  isDuplicate(item: string): boolean {
    return this.count(item) > 1;
  }
}
